import { api } from './api';

// Check if push notifications are supported
export const isPushSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!isPushSupported()) {
    console.log('Push notifications not supported');
    return 'unsupported';
  }
  
  const permission = await Notification.requestPermission();
  console.log('Notification permission:', permission);
  return permission;
};

// Get current permission status
export const getNotificationPermission = () => {
  if (!isPushSupported()) return 'unsupported';
  return Notification.permission;
};

// Subscribe to push notifications
export const subscribeToPush = async () => {
  try {
    // Check permission
    const permission = await requestNotificationPermission();
    if (permission !== 'granted') {
      return { success: false, error: 'Permission denied' };
    }
    
    // Get VAPID public key from server
    const { data: vapidData } = await api.get('/push/vapid-public-key');
    const publicKey = vapidData.publicKey;
    
    // Convert VAPID key to Uint8Array
    const urlBase64ToUint8Array = (base64String) => {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    };
    
    // Get service worker registration
    const registration = await navigator.serviceWorker.ready;
    
    // Subscribe to push
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
    
    // Send subscription to server
    const subscriptionJson = subscription.toJSON();
    await api.post('/push/subscribe', {
      endpoint: subscriptionJson.endpoint,
      keys: subscriptionJson.keys
    });
    
    console.log('Push subscription successful');
    return { success: true, subscription };
  } catch (error) {
    console.error('Push subscription error:', error);
    return { success: false, error: error.message };
  }
};

// Unsubscribe from push notifications
export const unsubscribeFromPush = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
      await subscription.unsubscribe();
    }
    
    await api.delete('/push/unsubscribe');
    
    return { success: true };
  } catch (error) {
    console.error('Push unsubscribe error:', error);
    return { success: false, error: error.message };
  }
};

// Check if user is subscribed
export const isPushSubscribed = async () => {
  try {
    if (!isPushSupported()) return false;
    
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    return !!subscription;
  } catch (error) {
    console.error('Error checking push subscription:', error);
    return false;
  }
};

// Send test notification
export const sendTestNotification = async () => {
  try {
    const response = await api.post('/push/test');
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Test notification error:', error);
    return { success: false, error: error.response?.data?.detail || error.message };
  }
};

// Send daily reminder (for manual trigger)
export const sendDailyReminder = async () => {
  try {
    const response = await api.post('/push/send-daily-reminder');
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Daily reminder error:', error);
    return { success: false, error: error.response?.data?.detail || error.message };
  }
};
